import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      isGuest: false,
      setUser: (user) =>
        set({
          user,
          isGuest: false,
        }),
      clearUser: () =>
        set({
          user: null,
        }),
      enterAsGuest: () =>
        set({
          user: null,
          isGuest: true,
        }),
      clearSession: () =>
        set({
          user: null,
          isGuest: false,
        }),
    }),
    {
      name: "cohuertas-auth",
      partialize: (state) => ({
        user: state.user,
        isGuest: state.isGuest,
      }),
    },
  ),
);
